import React from 'react';

function Support() {
  return <div>TBD: Tickets management here</div>;
}

export default Support;
